import isUndefinedOrNull from '@zenbusiness/application-commons-utils/isUndefinedOrNull';
import Divider from '@zenbusiness/zui/Divider';
import Grid from '@zenbusiness/zui/Grid';
import Stack from '@zenbusiness/zui/Stack';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import FieldDetail from './FieldDetail';

export default function MerchantDetail({
  paymentMethod,
  digitalWallet,
  cardPresent,
  recurring,
  verificationMethod,
  merchantName,
  merchantLocation,
  merchantCategory
}) {
  const shouldReturnNull = [
    paymentMethod,
    digitalWallet,
    cardPresent,
    recurring,
    verificationMethod,
    merchantName,
    merchantLocation,
    merchantCategory
  ].every((field) => isUndefinedOrNull(field));

  if (shouldReturnNull) {
    return null;
  }

  return (
    <>
      <Divider />
      <Grid
        columnSpacing="8px"
        container
        pb={{ xs: '24px', md: '56px' }}
        pt={{ xs: '24px', md: '32px' }}
        px={{ xs: '24px', md: '32px' }}
        rowSpacing={{ xs: '16px', md: '32px' }}
      >
        <Grid
          item
          xs={12}
        >
          <Stack
            alignItems="center"
            direction="row"
            justifyContent="space-between"
          >
            <Text
              color="primary"
              size="xl"
              weight="medium"
            >
              Merchant Details
            </Text>
          </Stack>
        </Grid>
        <FieldDetail
          label="Payment Method"
          value={paymentMethod}
        />
        <FieldDetail
          label="Digital Wallet"
          value={digitalWallet}
        />
        <FieldDetail
          label="Card Present"
          value={cardPresent ? 'Yes' : 'No'}
        />
        <FieldDetail
          label="Recurring"
          value={recurring ? 'Yes' : 'No'}
        />
        <FieldDetail
          label="Verification Method"
          value={verificationMethod}
        />
        <FieldDetail
          label="Business Name"
          value={merchantName}
        />
        <FieldDetail
          label="Location"
          value={merchantLocation}
        />
        <FieldDetail
          label="Category"
          value={merchantCategory}
        />
      </Grid>
    </>
  );
}

MerchantDetail.propTypes = {
  paymentMethod: PropTypes.string,
  digitalWallet: PropTypes.string,
  cardPresent: PropTypes.bool,
  recurring: PropTypes.bool,
  verificationMethod: PropTypes.string,
  merchantName: PropTypes.string,
  merchantLocation: PropTypes.string,
  merchantCategory: PropTypes.string
};
